import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

// A render error in one route should not blank the whole app. React only
// supports error boundaries as class components (no hook equivalent).
export class ErrorBoundary extends React.Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <p className="text-lg font-semibold">Something went wrong.</p>
            <p className="mt-1 text-sm text-muted-foreground">
              Try reloading the page. If the problem persists, contact support.
            </p>
            <button
              type="button"
              className="mt-4 rounded-md border px-4 py-2 text-sm"
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
